













import {
    Component,
    Vue,
    Prop
    
} from "vue-property-decorator";
import {
    pageDataType,
    projectPageDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_PROJECT_DATA
} from "../store/actions.names";
import {
    SET_PROJECT_CURRENT_PAGE
} from "../store/mutations.names";
import axios from "axios";
import ProjectHeader from "../components/ProjectHeader.vue";
import PTextblock from "../components/PTextblock.vue";
import ProjectBanner from "../components/ProjectBanner.vue";
import ProjectConf from "../components/ProjectConf.vue";
import ProjectFac from "../components/ProjectFac.vue";
import ProjectFloor from "../components/ProjectFloor.vue";
import ProjectLoc from "../components/ProjectLoc.vue";
import ProjectSlider from "../components/ProjectSlider.vue";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    TimelineMax,
    Power1,
    Power2,
    Power4
} from "gsap";
import VueWow from "vue-wow";
import {
    UAnimateContainer,
    UAnimate
} from "vue-wow";
import relatedProject from "../components/relatedProject.vue";
@Component({
    name: "ProjectDetailsPage",
    components: {
        ProjectHeader,
        title_richtext: PTextblock,
        banner_image: ProjectBanner,
        project_detail_title_subtitle: ProjectConf,
        features_and_facilities_title_subtitle_image: ProjectFac,
        floor_plan: ProjectFloor,
        location: ProjectLoc,
        slider: ProjectSlider,
        related_projects: relatedProject,
        UAnimateContainer,
        UAnimate
        // ProjectComp
    }
})
export default class ProjectDetailsPage extends Vue {
    // @Getter("pageData") public pageData!: pageDataType;
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    //@Getter("projectParent") public projectParent!: any | null;
    @Getter("relatedProjects") public relatedProjectSearch!: any | null;
    @Action(FETCH_PROJECT_DATA)[FETCH_PROJECT_DATA]: any;
    @Mutation(SET_PROJECT_CURRENT_PAGE) public[SET_PROJECT_CURRENT_PAGE]: any;
    public HOST: string = HOST;
    public pageLoaded: boolean = false;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    public urlResolved = false;
    // public original: any | null = null;
    @Getter("projectList") public pages!: projectPageDataType[];
    // showCont: boolean = false;
    //public scroll: any | null = null;

    // get relatedProject(): projectPageDataType[] {
    //     return this.relatedProjectSearch({
    //         location: this.pageData.location,
    //         type: this.pageData.apartment_type
    //     });
    // }

    // onElementHeightChange(document.body, function (h) {
    //     console.log('Body height changed:', h)
    // })

    // to clear the timer use:
    // clearTimeout(document.body.onElementHeightChangeTimer);

    // DEMO:
    // document.write("click anywhere")
    // window.addEventListener('click', function () {
    //     document.body.style.height = Math.floor((Math.random() * 5000) + 1) + 'px'
    // })

    get allCompData(): any {
        return [...this.pageData.body, {
            id: `rel-poj-${this.pageData.body.length}`,
            type: "related_projects",
            // value: this.relatedProject
        }]
    }

    public projanim(): void {
        if (this.last) {
            this.$emit("loaded");
        }
    }

    get sortedFloorPlan(): any | null {
        if (!this.pageData) {
            return null;
        }
        let data: any = {};

        for (
            let index = 0; index < this.pageData.floor_plan_details.length; index++
        ) {
            const element = this.pageData.floor_plan_details[index];
            let d = element.value;
            d.id = element.id;
            d.type = element.type;
            data[d.floor_number] = d;
        }
        return data;
    }

    public getCompData(type: string, value: any) {
        if (type == "floor_plan") {
            value.plan = this.sortedFloorPlan;
        }
        return value;
    }

    public handleRouteChange(newVal: any, oldVal: any) {
        this.urlResolved = true;
    }
    public mounted() {
        //  if (this.pageData){
        //   this[FETCH_PROJECT_DATA](this.pageData.meta.parent.id);
        //   }
        let dc: any = this.pageData;
        if (dc) {
            this[FETCH_PROJECT_DATA](dc.meta.parent.id);
        }
        this.getHeight();

    }
    pageDataChangeHandler(val: any | null, oldval: any | null) {
        if (val) {
            this[FETCH_PROJECT_DATA](val.meta.parent.id);
        }
    }
    passLoaded() {
        this.$emit("loaded");
    }

    public getHeight() {
        var d: any = document;
        setTimeout(() => {
            // var proj = d.querySelector('.project-thumb');
            //  proj.style.backgroundColor = "red";
            document.body.style.height = 'initial';
            // console.log(proj.clientHeight);
        }, 4000);

    }

    // projectloaded() {
    //     this.$emit("loaded");
    // }
    // public relproj(): void {
    //   var relproj = new TimelineMax({});
    //   relproj.staggerFrom(".project-thumb", 0.4, {
    //     yPercent: 20,
    //     opacity: 0,
    //     // scale: 1.5,
    //     ease: Power2.easeOut
    //   });

    //   if (this.last) {
    //     this.$emit("loaded");
    //   }
    // }
    // public handleScroll() {
    //     let scrollpos;
    //     let d: any = document;
    //     window.addEventListener('scroll', function () {
    //         scrollpos = window.scrollY;
    //         if (scrollpos > 1500) {
    //             (this as any).showCont = true;

    //         }
    //         //  else {
    //         //     nav.classList.remove('navbar-fixed');
    //         //     // nav.classList.add('navbar-anim');
    //         // }
    //     });

    // }

    // destroyed() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // }

}
